import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = { class: "d-flex flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "max-w-md w-full space-y-8" }
const _hoisted_4 = {
  key: 1,
  class: "form-container"
}
const _hoisted_5 = { class: "form-link" }
const _hoisted_6 = { class: "v-label v-field-label" }
const _hoisted_7 = { class: "v-field__input" }

import Firmware from '@/types/Firmware';
import MultipleDeviceTypeAutoComplete from '@/components/AutoCompletes/MultipleDeviceTypeAutoComplete.vue';
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';
import { isDeviceTypesValide, isMemoValide } from '@/services/validators';
import { ref, watch, computed, ComputedRef } from 'vue';
import deviceType from '@/types/DeviceType';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'FirmwareUpdateForm',
  props: {
    loading: { type: Boolean },
    updating: { type: Boolean },
    loadedFirmware: {},
    updateAuthority: { type: Boolean }
  },
  emits: ['close-modal', 'send-form'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const firmware = ref<Firmware | undefined>(undefined);
const selectedDeviceTypes = ref<deviceType[]>([]);
const errors = ref<{ device_type: Array<string>; memo: Array<string> }>({
  device_type: [],
  memo: [],
});

const issetFirmwareFile: ComputedRef<boolean> = computed(() => {
  return (
    firmware.value?.firmware?.file_name !== undefined &&
    firmware.value?.firmware?.file_name !== '-' &&
    firmware.value?.firmware?.path_to_file !== undefined &&
    firmware.value?.firmware?.path_to_file !== '-'
  );
});

const firmwareFilePath: ComputedRef<string | undefined> = computed(() => {
  if (issetFirmwareFile.value) {
    return getRestAPIUrl.value + firmware.value?.firmware?.path_to_file;
  }
  return undefined;
});

const getRestAPIUrl: ComputedRef<string> = computed(() => {
  if (process.env.VUE_APP_REST_API_BASE_URL.slice(-1) !== '/') {
    return process.env.VUE_APP_REST_API_BASE_URL + '/';
  }
  return process.env.VUE_APP_REST_API_BASE_URL;
});

const isValide: ComputedRef<boolean> = computed(() => {
  return Object.values(errors.value).every((errors) => errors.length === 0);
});

const updateBtnText: ComputedRef<string> = computed(() => {
  return props.updating ?
    i18n.global.t('pages.firmwareList.form.button.saving') :
    i18n.global.t('common.saveBtn');
});

const validateAndSendForm = () => {
  if (props.updating) {
    return;
  }
  validateForm();
  if (isValide.value) {
    sendForm();
  }
};

watch(
  () => props.loadedFirmware,
  (newValue) => {
    firmware.value = newValue;
    if (newValue && newValue.device_types.length > 0) {
      selectedDeviceTypes.value = newValue.device_types;
    }
  },
  { deep: true }
);

const validateForm = () => {
  validateDeviceTypes();
  validateMemo();
};

const validateDeviceTypes = () => {
  const errorMessage = isDeviceTypesValide(selectedDeviceTypes.value);
  if (errorMessage === null) {
    errors.value.device_type = [];
    return;
  }
  errors.value.device_type = [errorMessage];
};

const validateMemo = () => {
  let errorMessage = isMemoValide(firmware.value?.memo);
  if (errorMessage === null) {
    errors.value.memo = [];
    return;
  }
  errors.value.memo = [errorMessage];
};

const sendForm = () => {
  emit('send-form', {
    firmware_id: firmware.value?.id,
    active: firmware.value?.active,
    memo: firmware.value?.memo,
    ar_device_type_ids: selectedDeviceTypes.value.map(
      (deviceType) => deviceType.id
    ),
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(vLoaderAnimation, {
              text: 'text-black',
              "loading-text-style": 'text-black text-lg',
              "loading-text": "loading"
            })
          ])
        ])
      ]))
    : (firmware.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_card, {
            class: "mx-auto",
            title: _unref(i18n).global.t('pages.firmwareList.form.title.update')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: firmware.value.active,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firmware.value.active) = $event)),
                    label: _unref(i18n).global.t('pages.firmwareList.valid'),
                    color: "secondary",
                    "hide-details": ""
                  }, null, 8, ["modelValue", "label"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.firmwareList.form.label.firmware')), 1),
                    _createElementVNode("div", _hoisted_7, [
                      (issetFirmwareFile.value)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            href: firmwareFilePath.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(firmware.value.firmware?.file_name), 1)
                            ]),
                            _: 1
                          }, 8, ["href"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" - ")
                          ], 64))
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "v-input__details" }, [
                      _createElementVNode("div", { class: "v-messages" })
                    ], -1))
                  ]),
                  _createVNode(_component_v_text_field, {
                    disabled: "",
                    modelValue: firmware.value.checksum,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firmware.value.checksum) = $event)),
                    color: "primary",
                    label: _unref(i18n).global.t('pages.firmwareList.form.label.hash'),
                    variant: "underlined"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(MultipleDeviceTypeAutoComplete, {
                    modelValue: selectedDeviceTypes.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDeviceTypes).value = $event)),
                    onBlur: validateDeviceTypes,
                    "error-messages": errors.value.device_type
                  }, null, 8, ["modelValue", "error-messages"]),
                  _createVNode(_component_v_text_field, {
                    class: "mt-4",
                    disabled: "",
                    modelValue: firmware.value.version,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((firmware.value.version) = $event)),
                    color: "primary",
                    label: _unref(i18n).global.t('pages.firmwareList.version'),
                    variant: "underlined"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_component_v_textarea, {
                    label: _unref(i18n).global.t('pages.firmwareList.form.label.memo'),
                    modelValue: firmware.value.memo,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((firmware.value.memo) = $event)),
                    "hide-details": true,
                    onChange: validateMemo,
                    "error-messages": errors.value.memo
                  }, null, 8, ["label", "modelValue", "error-messages"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, { class: "my-4" }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    class: "ma-2 reset-btn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close-modal')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.close')), 1)
                    ]),
                    _: 1
                  }),
                  (__props.updateAuthority)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "ma-2 exec-btn",
                        onClick: validateAndSendForm,
                        style: _normalizeStyle({
              backgroundColor: __props.updating ? '#B3B8BB' : '',
            })
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(updateBtnText.value), 1)
                        ]),
                        _: 1
                      }, 8, ["style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true)
}
}

})